import api from 'api';
import { DesignSections } from 'records/DesignSection';

export const DESIGN_SECTIONS_ASYNC_ACTION_START = 'DESIGN_SECTIONS_ASYNC_ACTION_START';
export const DESIGN_SECTIONS_ASYNC_ACTION_ERROR = 'DESIGN_SECTIONS_ASYNC_ACTION_ERROR';
export const DESIGN_SECTIONS_ASYNC_ACTION_SUCCESS = 'DESIGN_SECTIONS_ASYNC_ACTION_SUCCESS';
export const DESIGN_SECTIONS_UPDATE_ACTION_SUCCESS = 'DESIGN_SECTIONS_UPDATE_ACTION_SUCCESS';
export const DESIGN_SECTIONS_RESET_STATE = 'DESIGN_SECTIONS_RESET_STATE';

function designSectionsAsyncActionStart() {
  return {
    type: DESIGN_SECTIONS_ASYNC_ACTION_START,
  };
}

function designSectionsAsyncActionError(error) {
  return {
    type: DESIGN_SECTIONS_ASYNC_ACTION_ERROR,
    error,
  };
}

function designSectionsAsyncUpdateSuccess(data) {
  return {
    type: DESIGN_SECTIONS_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function updateDesignSections(data) {
  return {
    type: DESIGN_SECTIONS_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetDesignSectionsState() {
  return {
    type: DESIGN_SECTIONS_RESET_STATE,
  };
}

export function getDesignSectionsAsync(designId) {
  return (dispatch, getState) => {
    dispatch(designSectionsAsyncActionStart());
    return api.request(`designsections/list?designId=${ designId }`, 'get')
    .then((data) => {
      dispatch(designSectionsAsyncUpdateSuccess(data));
      return new DesignSections(data);
    })
    .catch((err) => {
      dispatch(designSectionsAsyncActionError('Unable to update design sections'));
      throw (err);
    });
  };
}
